
const mimemap={
	"image/jpeg":"jpg",
	"image/png":"png",
	"image/gif":"gif",
	"image/webp":"webp",
	"image/svg+xml":"svg",
}
export const mime2ext = (mime)=>mimemap[mime]||mime